'use client'
import TextWithLineBreaks from '@/components/TextWithlineBreak'
import { usePathname, useRouter } from 'navigation'
import { useLocale, useMessages, useTranslations } from 'next-intl'
import { useEffect, useRef, useState } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion'
import CompaniesFeedbacksSlider from './_components/CompaniesFeedbacksSlider'
import GetStartedSection from '@/components/GetStartedSection'

const ClientsLayout = ({ children, clients }) => {
  const t = useTranslations('clients-page')
  const messages = useMessages()
  const pathname = usePathname()
  const locale = useLocale()
  const router = useRouter()
  const tabs = Object.keys(messages['clients-page'].tabs)
  const allSections = Object.keys(messages['clients-page'].All)
  const [FilteredSections, setFilteredSections] = useState(allSections)
  const contentRef = useRef()
  const handleScrollTabsContainer = (n) => {
    const tabsContainer = document.querySelector('#fleet-tabs-container')

    const scrollPercentage =
      (tabsContainer.scrollLeft /
        (tabsContainer.scrollWidth - tabsContainer.clientWidth)) *
      100

    setHorizontalScrollPercentage(Math.ceil(scrollPercentage))
    tabsContainer.scrollBy({
      left: n,
      behavior: 'smooth',
    })
  }
  const handelChangeActiveTab = (key) => {
    if (t(`tabs.${key}.title`) === 'All') setFilteredSections(allSections)
    else {
      const filterSections = allSections.filter(
        (section) =>
          t(`All.${section}.companyCategory`) === t(`tabs.${key}.title`)
      )
      setFilteredSections(filterSections)
    }
    router.push(`/${t(`tabs.${key}.path`)}`, undefined, { shallow: false }) // Update URL without reloading the page
  }
  const [horizontalScrollPercentage, setHorizontalScrollPercentage] =
    useState(0)
  useEffect(() => {
    setHorizontalScrollPercentage(0)
  }, [])
  return (
    <div>
      <main>
        <section>
          <div className='container py-12'>
            <div className='grid grid-cols-1 md:grid-cols-12'>
              <h3 className='heading-common mb-6 col-span-9 md:col-span-10'>
                {t('title')}
              </h3>
              <TextWithLineBreaks
                elementClassName='text-[18px] md:text-[16px] col-span-9 md:col-span-8 leading-[1.6] font-light'
                lineBreakClassname='hidden xl:block'
                textKey='description'
                t={t}
                element='p'
              />
            </div>
          </div>
          <div className='container  md:mb-0 mb-5'>
            <div className={`flex items-center mb-5`}>
              <div
                className='cursor-pointer block md:hidden'
                onClick={() => handleScrollTabsContainer(-60)}
              >
                <ChevronLeft
                  color={`${
                    horizontalScrollPercentage > 0
                      ? 'black'
                      : '#9e9e9e'
                  }`}
                />
              </div>
              <div
                ref={contentRef}
                id='fleet-tabs-container'
                className='flex gap-5 hide-scroll-bar max-w-full overflow-x-auto overflow-y-hidden w-full  h-[28px]'
              >
                {tabs.map((key) => (
                  <button
                    type='button'
                    key={key}
                    onClick={() => handelChangeActiveTab(key)}
                    className={`relative font-light whitespace-nowrap outline-sky-400 transition ${
                      pathname === t(`tabs.${key}.path`) ? ' font-normal' : ''
                    }`}
                  >
                    {pathname === t(`tabs.${key}.path`) && (
                      <motion.span
                        layoutId='underline'
                        className={`absolute inline-block left-0 w-full h-[2px] bottom-0 z-10 first-letter bg-black `}
                        transition={{
                          type: 'spring',
                          bounce: 0.2,
                          duration: 0.6,
                        }}
                      />
                    )}
                    {t(`tabs.${key}.title`)}
                  </button>
                ))}
              </div>
              <div
                className='cursor-pointer block md:hidden'
                onClick={() => handleScrollTabsContainer(60)}
              >
                <ChevronRight
                  color={horizontalScrollPercentage >= 99 ? '#9e9e9e' : 'black'}
                />
              </div>
            </div>
          </div>
        </section>
        {children}
        <CompaniesFeedbacksSlider/>
        <GetStartedSection
        // firstButtonText = "Book a demo"
        // firstButtonLink = "https://calendly.com/rolzo"
        secondButtonText = "Contact us"
        secondButtonLink = "/contact"
        secondButttonPrimary = {true}
        locale={locale}
        />
      </main>
    </div>
  )
}
export default ClientsLayout
